import React from 'react';
import ObservationCard from './ObservationCard';
import './ObservationGrid.css';

const ObservationGrid = ({ observations }) => {
  if (observations.length === 0) {
    return (
      <div className="no-results">
        <p>No observations found. Try adjusting the query or check back later.</p>
      </div>
    );
  }

  return (
    <div className="observation-grid">
      {observations.map((obs) => (
        <ObservationCard key={obs.id} observation={obs} />
      ))}
    </div>
  );
};

export default ObservationGrid;
